module.exports = __webpack_public_path__ + "static/media/Покана.8a8f458f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2020/Покана.pdf
// module id = 110
// module chunks = 0